module.exports = __webpack_public_path__ + "img/ernesto.84acae31.jpg";